import { EpisodeRunners } from '../../../dorian-shared/types/story/Story';

export const getEpisodeRunnerName = (runner: EpisodeRunners) => {
  switch (runner) {
    case EpisodeRunners.RenPy:
      return 'RenPy';
    default:
      return 'Dorian';
  }
};

export const getEpisodeRunnerNames = () => Object.values(EpisodeRunners).map((runner) => ({
  id: runner,
  name: getEpisodeRunnerName(runner),
}));
